<div class="dish-item">
  <div class="dish-item__left">
    <div class="dish-item-default" *ngIf="!product?.externalPictureUrl; else picture">
      <img alt="default-image" class="dish-item-default__img" [src]="defaultPicture"/>
    </div>
    <ng-template #picture>
      <div class="dish-item-picture">
        <img [alt]="'dish-image-' + product.externalId" class="dish-item-picture__img" [src]="product.externalPictureUrl"/>
      </div>
    </ng-template>
  </div>
  <div class="dish-item__right">
    <div class="dish-item-name">
      {{product.name}}
    </div>
    <div class="dish-item-info">
      <div class="dish-item-info__left">
        <div class="dish-item-info__desc">{{product.description}}</div>
        <div class="dish-item-info__weight">SKU: {{product.sku}}</div>
      </div>
    </div>
  </div>
</div>
